/* eslint-disable no-unused-lets */
import Vue from 'vue';
import NewsLetter from './components/NewsLetter';
import ReferralForm from './components/ReferralForm';
import AisHitsWrapper from './components/AisHitsWrapper';
import Modal from './components/Modal';
import AccountHolderPage from './pages/AccountHolderPage';
import InstantSearch from 'vue-instantsearch';

Vue.use(InstantSearch);

Vue.component('NewsLetter', NewsLetter);
Vue.component('ReferralForm', ReferralForm)
Vue.component('Modal', Modal)
Vue.component('AisHitsWrapper', AisHitsWrapper)


/* eslint-disable no-new */
new Vue({
  el: '#app',

  components: {
    AccountHolderPage
  },
  mounted() {
    console.info('main app....');
    $('.testimonial-overlay-wrapper').slick({
      'mobileFirst':true
    });
    $.trumbowyg.svgPath = '/img/icons.svg';
    $('.trumbowyg-demo').trumbowyg({
      btns: [
        ['viewHTML'],
        ['undo', 'redo'], // Only supported in Blink browsers
        ['formatting'],
        ['strong', 'em', 'del'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
        ['unorderedList', 'orderedList'],
        ['horizontalRule'],
        ['removeformat'],
        ['fullscreen']
    ]
    });

    
    $('.header .nav ul ul').each(function(){

      var li = $(this).parent();
      var toggler = $('<span class="mobile-toggler"><i class="fa fa-angle-down" aria-hidden="true" /></span>').appendTo(li);

      $(toggler).click(function(){

          $(li).toggleClass('js-open');
      });
    });
  },
});



// WEBPACK FOOTER //
// ./js/app.js